<script>
import Button from "@/components/atoms/button";
import Icon from "@/components/atoms/icon";
import PopinAnchor from "@/components/molecules/popin-anchor";
import StateOverlay from "@/components/molecules/state-overlay";

export default {
  name: "AdresseLadOverview",
  components: { Button, PopinAnchor, Icon, StateOverlay },
  props: {
    adresse: {
      type: Object,
      required: false,
      default: null
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<template>
  <div>
    <div class="u-flex">
      <Icon
        name="shipping-lad"
        size="sm"
        variant="primary"
      />
      <div class="u-pl-sm">
        <p class="u-font-700 u-font-20 u-font-secondary u-mb-md">
          Mon adresse de livraison
        </p>
        <StateOverlay
          v-if="adresse"
          :is-loading="isLoading"
        >
          <p class="u-mb-xs u-font-15 u-font-500">
            {{ adresse.attributes.libelle }}
          </p>
          <p>
            {{ adresse.attributes.civilite }} {{ adresse.attributes.prenom }} {{ adresse.attributes.nom }}
          </p>
          <p>
            {{ adresse.attributes.adresse }}
          </p>
          <p>
            {{ adresse.attributes.code_postal }} {{ adresse.attributes.nom_commune }}
          </p>
          <p class="u-mb-sm">
            {{ adresse.attributes.tel }}
          </p>
          <PopinAnchor
            link
            variant="text-light"
            popin-size="md"
            aria-label="Voir les indications pour le livreur"
          >
            <template #button-content>
              Voir les indications pour le livreur
            </template>
            <p class="u-p-xs">
              <strong>Type d'habitation :</strong> {{ uppercaseFirstLetter(adresse.attributes.type_habitation) }} <br>
              <strong>Étage :</strong> {{ adresse.attributes.etage }} <br>
              <template v-if="adresse.attributes.digicode1">
                <strong>Digicode :</strong> {{ adresse.attributes.digicode1 }} <br>
              </template>
              <template v-if="adresse.attributes.digicode2">
                <strong>Digicode 2 :</strong> {{ adresse.attributes.digicode2 }} <br>
              </template>
              <strong>Ascenseur :</strong> {{ booleanToText(adresse.attributes.ascenseur) }} <br>
              <strong>Interphone :</strong> {{ booleanToText(adresse.attributes.interphone) }} <br>
              <template v-if="adresse.attributes.info_livreur">
                <br><strong>Informations complémentaire : </strong><br>
                {{ adresse.attributes.info_livreur }}
              </template>
            </p>
          </PopinAnchor>
        </stateOverlay>
      </div>
    </div>

    <div class="u-text-center u-mt-md">
      <Button
        variant="primary"
        radius="full"
        size="sm"
        to="/mon-compte/mes-adresses"
      >
        Voir toutes mes adresses
      </Button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
